<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template>
            <el-input
                v-model="search.searchKey"
                clas="input_search"
                clearable
                placeholder="输入订单号/邮箱"
                style="margin-right: 10px"
                @keyup.enter.native="getserviceList"
            ></el-input>
            <el-select
                v-model="search.payStatus"
                clearable
                filterable
                placeholder="支付状态"
            >
              <el-option
                  v-for="item in PAY_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select v-model="search.putWay" clearable filterable placeholder="投放方式">
              <el-option
                  v-for="item in touFangList"
                  :key="item.enumId"
                  :label="item.enumName"
                  :value="item.enumVal"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.appInfoId"
                clearable
                filterable
                placeholder="下单应用"
            >
              <el-option
                  v-for="item in appList"
                  :key="item.appInfoId"
                  :label="item.appName"
                  :value="item.appInfoId"
              ></el-option>
            </el-select>
            <el-select
                v-model="search.channelAccountId"
                clearable
                filterable
                placeholder="下单渠道"
            >
              <el-option
                  v-for="item in channelList"
                  :key="item.channelAccountId"
                  :label="item.name+'('+item.account+')'"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
            <el-select v-model="search.newChannelOrder" clearable filterable placeholder="来源">
              <el-option
                  v-for="item in NEWUSER_ORDER"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-select v-model="search.countryCode" clearable filterable placeholder="国家/地区">
              <el-option
                  v-for="item in countryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
              ></el-option>
            </el-select>

            <el-select v-model="search.genderCode" clearable filterable placeholder="性别">
              <el-option
                  v-for="item in GENDER_OPTIONS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <div style="display:inline-block;margin-right: 10px">
              <div class="block timeblock" style="width: 400px;margin-bottom: 10px">
                <el-select
                    v-model="search.timeType"
                    class='xq_time_select'
                    clearable
                    placeholder="选择时间"
                    style="margin: 0"
                >
                  <el-option
                      v-for="item in TIME_TYPE"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                  ></el-option>
                </el-select>
                <el-date-picker

                    v-model="value2"
                    :picker-options="pickerOptions"
                    align="right"
                    class='xq_time_picker'
                    end-placeholder="结束日期"
                    range-separator="至"
                    start-placeholder="开始日期"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </div>
            </div>

            <el-button size="medium" type="primary" @click="getserviceList(1)"
            >查询
            </el-button
            >
          </template>
          <el-button size="medium" type="primary" @click="upserviceList"
          >下载
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              element-loading-text="等待接口数据返回中······"
              :data="tableData"
              border
              row-key="customerServiceId"
              size="medium"
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="国家/地区" min-width="120" prop="countryName">
            </el-table-column>
            <el-table-column label="语言" prop="hl">
            </el-table-column>
            <!-- <el-table-column label="标题" min-width="200" prop="name"></el-table-column> -->
            <!-- <el-table-column label="测评题" prop="examId"></el-table-column> -->
            <el-table-column label="订单号" min-width="200" prop="orderNumber">
            </el-table-column>
            <el-table-column label="订单金额" min-width="100" prop="orderMoney">
              <template slot-scope="scope">
                $ {{ scope.row.orderMoney/100 }}
              </template>
            </el-table-column>
            <el-table-column label="支付状态" prop="payStatusName">
              <template slot-scope="scope">
                <span :style="scope.row.payStatus == 0 ?'': 'color: #28AB80'">{{ scope.row.payStatusName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="支付类型" prop="paymentWay" width="120"/>
            <el-table-column label="支付方式" prop="paymentType" width="120"/>
            <el-table-column label="第一节(行为回避)" prop="energyStatus"/>
            <el-table-column label="第二节(反刍)" prop="lakeStatus"/>
            <el-table-column label="第三节(情绪调节)" prop="talentType"/>
            <el-table-column label="第四节(依恋关系)" prop="step4Status"/>
            <el-table-column label="第五节(童年阴影)" prop="step5Status"/>
            <el-table-column label="第六节(PHQ-9)" prop="step6Status"/>
            <el-table-column label="答题时长" prop="duration">
              <template slot-scope="scope" v-if="scope.row.duration">
                {{ Math.floor(scope.row.duration / 60) }}分{{ scope.row.duration % 60 }}秒
              </template>
            </el-table-column>
            
            <!-- <el-table-column label="支付回调事件" prop="paymentCallbackEvent" width="120">
            </el-table-column> -->
            <el-table-column label="投放方式" prop="putWayName">
            </el-table-column>
            <el-table-column label="下单应用" min-width="120" prop="appInfoId">
              <template slot-scope="scope">
                <div>{{ !isEmpty(scope.row.appInfoVo) ? scope.row.appInfoVo.appName : '' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="下单渠道" prop="channelAccountVo" width="180">
              <template slot-scope="scope">
                <span>({{ !isEmpty(scope.row.channelAccountVo) ? scope.row.channelAccountVo.channelTypeName : '' }}){{
                    !isEmpty(scope.row.channelAccountVo) ? scope.row.channelAccountVo.name : ''
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="来源" prop="newChannelOrder">
              <template slot-scope="scope">
                {{
                  scope.row.newChannelOrder == 1
                      ? "一转"
                      : scope.row.newChannelOrder == 2
                      ? "二转"
                      : "其它"
                }}
              </template>
            </el-table-column>
            <el-table-column label="意向分类" min-width="160" prop="prefGrowthName"/>
            <el-table-column label="渠道名称" min-width="160" prop="channelName"/>
            <el-table-column label="用户邮箱" min-width="180" prop="email">
              <template slot-scope="scope">
                <div>{{ scope.row.email }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="age" label="年龄组" width="120">
            </el-table-column>
            <el-table-column prop="gender" label="性别" width="100"></el-table-column>
            <el-table-column label="用户IP" min-width="240" prop="ip"/>
            <el-table-column label="下单时间" min-width="160" prop="ctime"></el-table-column>
            <el-table-column label="支付时间" min-width="160" prop="payTime"></el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <div class="button_code">
                  <el-button
                      v-if="detailShow"
                      size="mini"
                      @click="getOrderDetail(scope.row)"
                  >详情
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="showUserActionLogs(scope.row)"
                  >用户日志
                  </el-button>
                  <el-popover
                      v-if="qrcodeShow && scope.row.examPostId != 0 && scope.row.examPostId"
                      placement="bottom"
                      trigger="hover"
                      width="150px"
                  >
                    <template>
                      <app-qr-code :correctLevel="3"
                              :logoMargin="5"
                              :logoScale=".2"
                              :logoSrc="require('../../assets/images/taotanlogo_back.png')"
                              :margin="10"
                              :size="100"
                              :text="'http://exl.xyunxin.com/report/content-'+scope.row.orderNumber"
                              backgroundColor="white"
                              backgroundDimming="white"
                              colorDark="#000000"
                              colorLight="white"
                              logoBackgroundColor="white"
                      ></app-qr-code>
                    </template>
                    <span
                        slot="reference"
                        class="name-wrapper"
                    >
                    <img src="../../assets/images/code.png">
                  </span>
                  </el-popover>
                </div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :total="page.count"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
        title="用户行为日志"
        :visible.sync="userActionLogsDialogVisible"
        width="760px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
        <el-form v-loading="userActionLogsLoading">
          <b>订单号：</b>{{params.orderNumber}} <br/>
          <b>网络：</b>{{params.userNetwork}} <br/>
          <b>浏览器：</b>{{params.userAgent}} <br/><br/>
        <el-table
            :data="userActionLogs"
            border
            row-key="id"
            size="medium"
            style="width: 100%"
            height="500px"
        >
          <el-table-column label="时间" min-width="60" prop="ctime">
          </el-table-column>
          <el-table-column label="事件" min-width="180" prop="action">
          </el-table-column>
        </el-table>
        </el-form>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="userActionLogsDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  PAY_STATUS,
  PAYMENT_TYPE,
  NEWUSER_ORDER,
  TIME_TYPE,
  GENDER_OPTIONS,
} from "@/config";

import {isEmpty} from "@utils/tools/index";
import AppQrCode from "@/components/AppQrCode";
import { downloadFile } from '@/utils/filters/upload.js'

export default {
  components: {
    AppQrCode
  },
  data() {
    return {
      qrcodeText: "舒工请你付款来了", //二维码内容（扫码识别后需要访问的网址）
      amount: 168,//金额
      PAGE_SIZE,
      PAY_STATUS,
      PAYMENT_TYPE,
      NEWUSER_ORDER,
      TIME_TYPE,
      GENDER_OPTIONS,
      paymentList:[],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      countryList: [],
      examList: [],
      isEmpty,//需要在此初始化才可以在页面使用
      value2: "", //以上时间选择器
      enumCode: "PUT_WAY",
      touFangList: [], //渠道用户投放方式
      categoryList: [], //测评题分类数组
      dictDataSelect: "", //测评题tree点击后显示
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        children: "examCategoryVos",
        label: "name",
      },
      channelList: [], //渠道类型list
      appList: [], //归属应用appid
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表
      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写客服名称"}],
        account: [{required: true, message: "请填写账号"}],
        offTime: [{required: true, message: "请填写结束时间"}],
        onTime: [{required: true, message: "请填写开始时间"}],
      }, //表单验证提示

      detailShow: false,
      qrcodeShow: false,
      userActionLogsDialogVisible: false,
      userActionLogsLoading: false,
      userActionLogs: [],
    };
  },
  mounted() {
    this.getAppList();
    this.getChannelList();
    this.gettouFangList();
    // this.getCategoryList();
    this.getserviceList();
    // this.getPermissionButtonList();
    this.getCountryList();
    // this.getExamList();
    this.getPaymentList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    async getCountryList() {
      const {data: res} = await this.$post(
          `/country/page`, {pageNo: 1, pageSize: 1000},
      );
      this.countryList = res.data;
    },
    async getPaymentList(){
      const {data: resData} = await this.$get(
          "/payment/type/list",
      );

      if (resData.result != 200) return;
      this.paymentList = resData.data;
    },
    async getExamList() {
      const {data} = await this.$get(`/exam/list?status=1&pageNo=1&pageSize=1000`);
      this.examList = data.data;
    },
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == "order:exam:detail") {
            this.detailShow = true
          }
          if (item.code == "order:exam:detail:qrcode") {
            this.qrcodeShow = true
          }
        })
      }
    },

    goShowReport(item) {
      let url = 'http://exl.xyunxin.com/report/content-' + item.orderNumber
      // let url = 'http://test.h5.cdtaotan.com/report/content-'+item.orderNumber
      window.open(url)
    },
    //获取归属应用
    async getAppList() {
      const {data: orgData} = await this.$get(`/app/list?paging=false&appType=WEBSIT`);
      this.appList = orgData.data;
    },
    //获取渠道账号
    async getChannelList() {
      // const { data: orgData } = await this.$get(`/channel/type/list`);
      const {data: orgData} = await this.$get(`/channel/account/list?paging=false`);
      this.channelList = orgData.data;
    },
    // 获取渠道用户投放方式
    async gettouFangList() {

      const {data: orgData} = await this.$get(`/enums/list/${this.enumCode}`);

      this.touFangList = orgData.data;
    },
    //get categoryList:[],//测评题分类数组
    async getCategoryList() {
      const {data: res} = await this.$get(`/exam/category/list?tree=true`, {
        headers: {
          isLoading: true,
        },
      });
      this.categoryList = res.data;
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      let obj = this.search
      let startTime = obj.startTime ? obj.startTime : ''
      let endTime = obj.endTime ? obj.endTime : ''
      if (startTime && endTime) {
        // const {data: res} = await this.$get(
        //     `/exam/order/export/create`,
        //     {params: {...this.search}},
        //     {
        //       headers: {
        //         // isLoading: true,
        //       },
        //     }
        // );
        // this.$message.success(res.data)
        let queryString = ''
        for (const key in this.search) {
          if (this.search.hasOwnProperty(key) && this.search[key]) {
            queryString += `${key}=${this.search[key]}&`;
          }
        }
        // 移除字符串末尾的多余的 '&' 符号
        queryString = queryString.slice(0, -1);

        // window.open(`/taotan_admin_api/exam/order/export/examOrder?timeType=${this.search.timeType}&startTime=${startTime}&endTime=${endTime}`);
        const downloadUrl = `/taotan_admin_api/med/order/export/create?${queryString}`
        downloadFile(downloadUrl, `examOrder_${new Date().getTime()}.csv`)
      } else {
        this.$message.warning('请选择时间')
      }
    },
    //订单列表
    async getserviceList(e) {
      if (e == 1) {
        this.page.pageNo = 1;
      }
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      } else {
        delete this.search.startTime
        delete this.search.endTime
        delete this.search.timeType
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      this.loading = true;
      const search = this.search;
      ['examInfoId', 'countryCode'].forEach(
          itemKey => {
            if (!search[itemKey]) {
              delete search[itemKey]
            }
          }
      )
      this.removeEmptyProperties(search)
      const {data: res} = await this.$get(
          `/med/order/list`,
          {params: {...search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      let list = res.data
      if (list) {
        list.forEach((item) => {
          item.payMoney = item.payMoney / 100
        })
      }
      this.tableData = list;
      this.page.count = res.page.count;
    },
    removeEmptyProperties(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
          delete obj[key];
        }
      }
    },
    //订单详情
    getOrderDetail(row) {
      this.$router.push({
        name: 'TEST_ORDER_DETAIL',
        query: {
          title: '测评订单',
          value: JSON.stringify(row.orderNumber),
        }
      })
      // this.$router.push({
      //   name: 'ORDER_DETAIL',
      //   query: {
      //     id: 0,
      //     title: '测评订单',
      //     key: 'orderNumber',
      //     value: JSON.stringify(row.orderNumber),
      //     path: '/exam/order/info',
      //   }
      // })
    },
    //订单详情
    async showUserActionLogs(row) {
      this.userActionLogsDialogVisible = true;
      this.userActionLogsLoading = true;
      const {data: resData} = await this.$get(
          `/exam/order/userActionLogs`,
          {params: {orderNumber: row.orderNumber, deviceId: row.deviceId}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.userActionLogsLoading = false;
      this.userActionLogs = resData.data;
      this.params = row;
    },

    //tree 点击  categoryId:测评题分类id
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.search.categoryId = node.categoryId;
      this.$refs.selectReport.blur();
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.el-select {
  margin-bottom: 10px;
  margin-right: 10px;
}

.name-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-left: 10px;

  img {
    width: 25px;
    height: 25px;
  }
}

.button_code {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-button--small, .el-button--small.is-round {
    padding: 11px 15px !important;
  }
}
</style>
